/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Text, TEXT_VARIANTS } from '..';

const COLORS = {
  GREEN: "#00FF38",
  LIME: "#e2fea4",
  LIGHT: "#f6f6f9",
  SILVER: "#949CA6",
  BLUE: "#0075FF",
  BLACK: "#000",
  NUMBER: "#C3C9D0",
  WHITE: "#fff",
} as const;

export const ExternalLink: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLAnchorElement>>
> = ({ children, ...props }) => (
  <Text
    as="a"
    variant={TEXT_VARIANTS.T20}
    css={css`
      cursor: pointer;
      width: fit-content;
      color: ${COLORS.BLUE};

      &:hover {
        text-decoration: underline;
      }
    `}
    {...(props as any)}
  >
    {children}
  </Text>
);
